<template>
  <div class="dashboard-page-root">
    <AppNavbar />

    <main class="dashboard-main">
      <section class="coming-soon-shell">
        <div class="ambient-glow glow-one"></div>
        <div class="ambient-glow glow-two"></div>

        <div class="coming-soon-card">
          <span class="eyebrow-chip">
            <i class="ri-dashboard-3-line"></i>
            My Dashboard
          </span>

          <h1 class="coming-title">Coming Soon</h1>

          <!-- <p class="coming-description">
            We are crafting a smarter dashboard experience for you with profile
            insights, order analytics, and personalized shopping shortcuts.
          </p> -->

          <div class="action-row">
            <router-link :to="{ name: 'profile' }" class="action-btn primary">
              <i class="ri-user-line"></i>
              My Profile
            </router-link>
            <button
              v-if="!isSelfCheckoutUser"
              type="button"
              class="action-btn ghost"
              @click="openMyTree"
            >
              <i class="ri-git-branch-line"></i>
              <!-- My Dashboard -->
              My Tree
            </button>
            <!-- <button
              v-if="!isSelfCheckoutUser && !isImportedUser"
              type="button"
              class="action-btn ghost"
              @click="openPlacement"
            >
              <i class="ri-route-line"></i>
              Placement
            </button> -->
            <router-link
              :to="{ name: 'order-status' }"
              class="action-btn ghost"
            >
              <i class="ri-file-list-3-line"></i>
              View Orders
            </router-link>
          </div>
        </div>
      </section>
    </main>

    <div
      v-if="showTreePopup"
      class="tree-popup-overlay"
      @click.self="showTreePopup = false"
    >
      <div class="tree-popup-box">
        <button
          type="button"
          class="tree-popup-close"
          @click="showTreePopup = false"
        >
          <i class="ri-close-line"></i>
        </button>
        <iframe
          class="tree-popup-iframe"
          :src="treeUrl"
          title="My Tree"
        ></iframe>
      </div>
    </div>

    <div
      v-if="showPlacementPopup"
      class="placement-popup-overlay"
      @click.self="showPlacementPopup = false"
    >
      <div class="placement-popup-box">
        <button
          type="button"
          class="placement-popup-close"
          @click="showPlacementPopup = false"
        >
          <i class="ri-close-line"></i>
        </button>
        <iframe
          class="placement-popup-iframe"
          :src="placementUrl"
          title="Placement"
        ></iframe>
      </div>
    </div>

    <FooterView />
  </div>
</template>

<script>
import AppNavbar from "../AppNavbar.vue";
import FooterView from "../FooterView.vue";

const BA_URL = String(process.env.VUE_APP_BA_URL || "https://ba-ui.qa.rdep.io");

export default {
  name: "MyDashboardView",
  components: {
    AppNavbar,
    FooterView,
  },
  data() {
    return {
      showTreePopup: false,
      treeUrl: "",
      showPlacementPopup: false,
      placementUrl: "",
      userRoleToken: "",
      currentUser: {},
    };
  },
  computed: {
    isSelfCheckoutUser() {
      return this.userRoleToken.includes("SELF_CHECKOUT");
    },
    isImportedUser() {
      const importedRaw =
        this.currentUser?.imported ?? this.currentUser?.data?.imported ?? false;

      return (
        importedRaw === true ||
        importedRaw === 1 ||
        String(importedRaw || "").toLowerCase() === "true"
      );
    },
  },
  methods: {
    normalizeRoleToken(value) {
      return String(value || "")
        .trim()
        .toUpperCase()
        .replace(/[^A-Z0-9]+/g, "_")
        .replace(/^_+|_+$/g, "");
    },
    resolveUserRoleToken(user) {
      const payload = user || {};

      const roleCandidates = [
        payload.userType,
        payload.role,
        payload.customerType,
        payload.loginRole,
        payload.accountType,
      ]
        .map(this.normalizeRoleToken)
        .filter(Boolean);

      return roleCandidates[0] || "";
    },
    initializeUserRoleToken() {
      let authPayload = {};
      const rawAuth = window.localStorage.getItem("auth.currentUser");
      if (rawAuth) {
        try {
          authPayload = JSON.parse(rawAuth) || {};
        } catch (error) {
          authPayload = {};
        }
      }

      const user = authPayload?.data || authPayload || {};
      this.currentUser = user;
      this.userRoleToken = this.resolveUserRoleToken(user);
    },
    openMyTree() {
      if (this.isSelfCheckoutUser) {
        return;
      }

      let authPayload = {};
      const rawAuth = window.localStorage.getItem("auth.currentUser");
      if (rawAuth) {
        try {
          authPayload = JSON.parse(rawAuth) || {};
        } catch (error) {
          authPayload = {};
        }
      }
      const user = authPayload?.data || authPayload || {};

      const baId = encodeURIComponent(
        String(
          user.username ||
            user.distributorCode ||
            user.businessAssociateId ||
            "",
        ).trim(),
      );
      const baName = encodeURIComponent(
        String(
          user.firstName ||
            user.name ||
            user.fullName ||
            user.customerName ||
            "",
        ).trim(),
      );
      // for my dashboard
      // this.treeUrl = `${BA_URL}/?step=1&baId=${baId}&baName=${baName}&registrationToken=abc`;
      this.treeUrl = `${BA_URL}/?step=99&baId=${baId}&baName=${baName}`;
      this.showTreePopup = true;
    },
    openPlacement() {
      if (this.isSelfCheckoutUser || this.isImportedUser) {
        return;
      }

      const user = this.currentUser || {};
      const distributorCode = encodeURIComponent(
        String(
          user.distributorCode ||
            user.username ||
            user.businessAssociateId ||
            "",
        ).trim(),
      );
      const name = encodeURIComponent(
        String(
          user.name ||
            user.fullName ||
            user.firstName ||
            user.customerName ||
            "",
        ).trim(),
      );

      this.placementUrl = `${BA_URL}/?step=2_self&newBaId=${distributorCode}&newBaName=${name}&registrationToken=abc`;
      this.showPlacementPopup = true;
    },
  },
  created() {
    this.initializeUserRoleToken();
  },
};
</script>

<style scoped>
.dashboard-page-root {
  min-height: 100vh;
  background: radial-gradient(
    circle at 12% 10%,
    #e7eefc 0,
    #f8fbff 32%,
    #ffffff 70%
  );
}

.dashboard-main {
  width: 90%;
  max-width: 1240px;
  margin: 0 auto;
  padding: 36px 0 68px;
}

.coming-soon-shell {
  position: relative;
  padding: 22px;
  border-radius: 26px;
  background: linear-gradient(
    135deg,
    rgba(0, 61, 165, 0.06),
    rgba(255, 199, 44, 0.12)
  );
  overflow: hidden;
}

.ambient-glow {
  position: absolute;
  border-radius: 999px;
  filter: blur(2px);
}

.glow-one {
  width: 280px;
  height: 280px;
  top: -110px;
  right: -50px;
  background: radial-gradient(
    circle,
    rgba(255, 199, 44, 0.38) 0%,
    rgba(255, 199, 44, 0) 70%
  );
}

.glow-two {
  width: 240px;
  height: 240px;
  bottom: -100px;
  left: -40px;
  background: radial-gradient(
    circle,
    rgba(0, 61, 165, 0.25) 0%,
    rgba(0, 61, 165, 0) 72%
  );
}

.coming-soon-card {
  position: relative;
  z-index: 1;
  background: #ffffff;
  border: 1px solid rgba(0, 61, 165, 0.14);
  border-radius: 22px;
  padding: 48px 44px;
  box-shadow: 0 16px 45px rgba(10, 34, 64, 0.12);
  text-align: center;
}

.eyebrow-chip {
  display: inline-flex;
  align-items: center;
  gap: 8px;
  background: rgba(0, 61, 165, 0.08);
  border: 1px solid rgba(0, 61, 165, 0.14);
  color: #003da5;
  font-size: 12px;
  font-weight: 700;
  text-transform: uppercase;
  letter-spacing: 1.2px;
  padding: 8px 14px;
  border-radius: 999px;
}

.eyebrow-chip i {
  font-size: 14px;
}

.coming-title {
  margin: 0;
  padding-top: 22px;
  font-size: clamp(36px, 5vw, 58px);
  line-height: 1;
  font-weight: 800;
  color: #0a2240;
  letter-spacing: -1.4px;
}

.coming-description {
  margin: 16px auto 0;
  max-width: 640px;
  color: #333f48;
  line-height: 1.6;
  font-size: 17px;
}

.action-row {
  margin-top: 28px;
  display: flex;
  justify-content: center;
  gap: 14px;
  flex-wrap: wrap;
}

.action-btn {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  font-family: inherit;
  min-width: 164px;
  padding: 12px 18px;
  border-radius: 999px;
  text-decoration: none;
  font-size: 14px;
  font-weight: 700;
  transition: transform 0.2s ease, box-shadow 0.2s ease,
    background-color 0.2s ease;
}

.action-btn i {
  font-size: 15px;
  line-height: 1;
}

.action-btn.primary {
  background: #003da5;
  border: 1px solid #003da5;
  color: #ffffff;
  box-shadow: 0 10px 22px rgba(0, 61, 165, 0.28);
}

.action-btn.ghost {
  background: #ffffff;
  border: 1.5px solid #003da5;
  color: #003da5;
  cursor: pointer;
}

.action-btn:hover {
  transform: translateY(-2px);
}

.action-btn.primary:hover {
  box-shadow: 0 14px 28px rgba(0, 61, 165, 0.34);
}

.action-btn.ghost:hover {
  background: #003da5;
  color: #ffffff;
}

.tree-popup-overlay {
  position: fixed;
  inset: 0;
  background: rgba(10, 34, 64, 0.55);
  z-index: 2000;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 24px;
}

.tree-popup-box {
  width: min(1100px, 96vw);
  height: min(760px, 92vh);
  background: #ffffff;
  border-radius: 14px;
  overflow: hidden;
  box-shadow: 0 24px 60px rgba(10, 34, 64, 0.35);
  display: flex;
  flex-direction: column;
}

.tree-popup-close {
  height: 44px;
  border: none;
  border-bottom: 1px solid #e2eaf6;
  background: #ffffff;
  color: #0a2240;
  font-size: 14px;
  font-weight: 700;
  cursor: pointer;
  display: inline-flex;
  align-items: center;
  gap: 6px;
  padding: 0 14px;
  align-self: flex-end;
  font-family: inherit;
}

.tree-popup-iframe {
  width: 100%;
  height: 100%;
  border: 0;
  flex: 1;
}

.placement-popup-overlay {
  position: fixed;
  inset: 0;
  background: rgba(10, 34, 64, 0.55);
  z-index: 2000;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 24px;
}

.placement-popup-box {
  width: min(1100px, 96vw);
  height: min(760px, 92vh);
  background: #ffffff;
  border-radius: 14px;
  overflow: hidden;
  box-shadow: 0 24px 60px rgba(10, 34, 64, 0.35);
  display: flex;
  flex-direction: column;
}

.placement-popup-close {
  height: 44px;
  border: none;
  border-bottom: 1px solid #e2eaf6;
  background: #ffffff;
  color: #0a2240;
  font-size: 14px;
  font-weight: 700;
  cursor: pointer;
  display: inline-flex;
  align-items: center;
  gap: 6px;
  padding: 0 14px;
  align-self: flex-end;
  font-family: inherit;
}

.placement-popup-iframe {
  width: 100%;
  height: 100%;
  border: 0;
  flex: 1;
}

@media (max-width: 1024px) {
  .coming-soon-card {
    padding: 42px 30px;
  }
}

@media (max-width: 640px) {
  .dashboard-main {
    width: 92%;
    padding-top: 22px;
  }

  .coming-soon-shell {
    padding: 14px;
  }

  .coming-soon-card {
    padding: 34px 18px;
  }

  .coming-description {
    font-size: 15px;
  }

  .action-row {
    gap: 10px;
  }

  .action-btn {
    width: 100%;
  }
}
</style>
